var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebook = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook account connect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.292969,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1F408C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8486 18.4532C14.781 18.4532 13.2941 18.4532 12.6183 18.4532C12.2578 18.4532 12.1452 18.318 12.1452 17.9801C12.1452 17.079 12.1452 16.1553 12.1452 15.2542C12.1452 14.8937 12.2804 14.7811 12.6183 14.7811H14.8486C14.8486 14.7135 14.8486 13.4069 14.8486 12.7986C14.8486 11.8975 15.0063 11.0414 15.4568 10.2529C15.9299 9.4419 16.6058 8.90123 17.4618 8.58583C18.0251 8.38308 18.5883 8.29297 19.1965 8.29297H21.4043C21.7197 8.29297 21.8548 8.42814 21.8548 8.74353V11.3117C21.8548 11.6271 21.7197 11.7623 21.4043 11.7623C20.796 11.7623 20.1878 11.7623 19.5795 11.7848C18.9712 11.7848 18.6558 12.0777 18.6558 12.7085C18.6333 13.3843 18.6558 14.0376 18.6558 14.736H21.2691C21.6296 14.736 21.7647 14.8712 21.7647 15.2316V17.9575C21.7647 18.318 21.6521 18.4306 21.2691 18.4306C20.4581 18.4306 18.7234 18.4306 18.6558 18.4306V25.7748C18.6558 26.1578 18.5432 26.293 18.1377 26.293C17.1915 26.293 16.2679 26.293 15.3217 26.293C14.9838 26.293 14.8486 26.1578 14.8486 25.8199C14.8486 23.4544 14.8486 18.5208 14.8486 18.4532Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook.e20d588e4039b1d6f62c2dbf5341e1d2.svg";